import { render, staticRenderFns } from "./CommonEmojiComponent.vue?vue&type=template&id=6a99dc01"
import script from "./CommonEmojiComponent.vue?vue&type=script&lang=js"
export * from "./CommonEmojiComponent.vue?vue&type=script&lang=js"
import style0 from "./CommonEmojiComponent.vue?vue&type=style&index=0&id=6a99dc01&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports